import { render } from "./success-message.vue?vue&type=template&id=2a6fc7cf&scoped=true"
import script from "./success-message.vue?vue&type=script&lang=js"
export * from "./success-message.vue?vue&type=script&lang=js"

import "./success-message.vue?vue&type=style&index=0&id=2a6fc7cf&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a6fc7cf"]])

export default __exports__